import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { NrkWindowComponent } from '../../../../shared/nrk-window/nrk-window.component';

@Component({
  selector: 'ngx-pfspo-charts',
  templateUrl: './pfspo-charts.component.html',
  styleUrls: ['./pfspo-charts.component.scss']
})
export class PfspoChartsComponent implements OnInit {

  @Input() parent = null;
  // @Input() columnOptions = null;
  // @Input() pfspoLineData = null;
  // @Input() filteredSpos = null;
  @Input() selectedSpo = null;
  @ViewChild('pfspoChartWin') pfspoChartWin: NrkWindowComponent;

  options = {};

  data: any;

  width = 1000;
  height = 500;

  constructor() { }

  ngOnInit() {
  }

  rebuildCharts() {

    this.data = {
      quantity: [],
      deliveredQ: [],
      assignedQ: [],
      freeQ: [],
      label: [],
      color: [],
    };

    const res = [];
    const products = this.parent.filteredSpos.filter(f => f.fpCode === this.selectedSpo.fpCode);
    console.log('asdfaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa', this.parent, this.parent.filteredSpos);
    products.forEach(p => {
      const color = this.parent.getStyle(p);
      this.data.quantity.push({
        value: [p.quantity, p.m2quantity, p.mquantity][this.parent.showSqm],
        itemStyle: { color: color['background-color'] },
      });
      this.data.deliveredQ.push([p.deliveredQ, p.m2deliveredQ, p.mdeliveredQ][this.parent.showSqm]);
      this.data.assignedQ.push([p.assignedQ, p.m2assignedQ, p.massignedQ][this.parent.showSqm]);
      this.data.freeQ.push([p.freeQ, p.m2freeQ, p.mfreeQ][this.parent.showSqm]);
      this.data.label.push(`${p.exwDate}\n${p.vieArrivalDate}\n${p.combinedShipment}\n${p.code}`)
    })
    this.options = this.getChartOptions();
  }

  getChartOptions() {
    return {
      tooltip: {},
      xAxis: {
        type: 'category',
        data: this.data.label,
      },
      yAxis: {
        type: 'value'
      },
      color: ['#5C7BD9', '#DDDDDD', '#AACCFF', '#77DD77'],
      series: [
        {
          name: 'Quantity',
          type: 'bar',
          stack: 'quantity',
          label: {
            show: true,
            position: 'inside'
          },
          data: this.data.quantity,
        },
        {
          name: 'Delivered',
          type: 'bar',
          stack: 'product',
          label: {
            show: true,
            position: 'inside'
          },
          data: this.data.deliveredQ
        },
        {
          name: 'Assigned',
          type: 'bar',
          stack: 'product',
          label: {
            show: true,
            position: 'inside'
          },
          data: this.data.assignedQ,
        },
        {
          name: 'Free',
          type: 'bar',
          stack: 'product',
          label: {
            show: true,
            position: 'inside'
          },
          data: this.data.freeQ,
        }
      ]
    };
  }

  onResize(elRef: ElementRef) {
    const div: HTMLDivElement = elRef?.nativeElement;
    console.log('element ref', elRef);
    if (div && div.clientWidth && div.clientHeight) {
      this.width = div.clientWidth - 10;
      this.height = div.clientHeight - 200;
      console.log('on end resize', div.clientWidth, div.clientHeight);
      this.rebuildCharts(); 
    }
  }
  

}
